import useClickOutside from "@admin/hooks/useClickOutside";
import { LocationUser } from "@enos-monorepo/lib";
import { useEffect, useRef, useState } from "react";

import { Info } from "./Info";

interface SelectPersonnelProps {
  personnels: LocationUser[];
  onSelectPersonnel: (personnel: LocationUser) => void;
}

export function SelectPersonnel({
  personnels,
  onSelectPersonnel,
}: SelectPersonnelProps) {
  const [selectedPersonnel, setSelectedPersonnel] =
    useState<LocationUser | null>(personnels.length > 0 ? personnels[0] : null);

  const [show, setShow] = useState(false);
  useEffect(() => {
    if (selectedPersonnel) {
      onSelectPersonnel(selectedPersonnel);
    }
  }, [onSelectPersonnel, selectedPersonnel]);

  const ref = useRef(null);

  useClickOutside(ref, () => setShow(false));

  const onClickPersonnel = (personnel: LocationUser) => {
    setSelectedPersonnel(personnel);
    setShow(false);
  };

  return (
    <div ref={ref} className="relative w-full cursor-pointer">
      <div
        onClick={() => setShow((prev) => !prev)}
        className="border-[1px] border-[#DBDFE9] rounded-md p-2 text-sm flex flex-row justify-between items-center"
      >
        <Info
          name={
            selectedPersonnel?.firstName + " " + selectedPersonnel?.lastName
          }
          userName={selectedPersonnel?.userName}
          userPhoto={selectedPersonnel?.userPhoto}
        />
        {show ? (
          <i className="ki-filled ki-up"></i>
        ) : (
          <i className="ki-filled ki-down"></i>
        )}
      </div>
      {show && (
        <div className="absolute left-0 flex flex-col z-40 bg-white w-full rounded-b-md overflow-hidden">
          {personnels.map((personnel) => (
            <div
              key={personnel.userId}
              className="px-4 py-2 border-b-[1px] cursor-pointer"
              onClick={() => onClickPersonnel(personnel)}
            >
              <Info
                name={personnel.firstName + " " + personnel.lastName}
                userName={personnel.userName}
                userPhoto={personnel.userPhoto}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
